import { render, staticRenderFns } from "./DeviceManage.vue?vue&type=template&id=de60b93a&scoped=true"
import script from "./DeviceManage.vue?vue&type=script&lang=js"
export * from "./DeviceManage.vue?vue&type=script&lang=js"
import style0 from "./DeviceManage.vue?vue&type=style&index=0&id=de60b93a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de60b93a",
  null
  
)

export default component.exports